import { companyBankFeedRoute } from '@/abilities/companyBankFeed/routes';
import { toCompanyBankFeedDestination } from '@/abilities/companyBankFeed/vocabulary';
import { createDestinationRoute } from '@/router/destinationRoute';
import { companyBankFeedDestinationRoutes } from '@/pages/company/BankFeedRoute/destinationRoutes';

export const companyBankFeedDestinationRoute = createDestinationRoute(
  companyBankFeedDestinationRoutes,
  toCompanyBankFeedDestination,
  companyBankFeedRoute,
);
